import { render } from "./ProfileLinks.vue?vue&type=template&id=db124814&scoped=true&ts=true"
import script from "./ProfileLinks.vue?vue&type=script&lang=ts"
export * from "./ProfileLinks.vue?vue&type=script&lang=ts"

import "./ProfileLinks.vue?vue&type=style&index=0&id=db124814&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db124814"]])

export default __exports__